var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDroppingArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.44268e-07 11.062C-1.54134e-07 13.2369 1.76309 15 3.93797 15L11.062 15C13.2369 15 15 13.2369 15 11.062L15 3.93797C15 1.76309 13.2369 7.50141e-07 11.062 9.40275e-07L3.93797 1.56308e-06C1.76309 1.75321e-06 -1.15721e-06 1.76309 -9.67073e-07 3.93797L-3.44268e-07 11.062Z",
    fill: "#FF512D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0893 10.3125L7.71096 6.96108L5.37596 9.19739L0.9375 4.86968L2.02503 3.75L5.3851 7.02667L7.72923 4.78273L12.1875 9.20349L11.0893 10.3125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.5L9.375 11.25L13.125 11.25L13.125 7.5Z",
    fill: "white",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroppingArticle);
export default __webpack_public_path__ + "static/media/dropping-article.39c4c04eb6ce45eca9c99c1deb6776e3.svg";
export { ForwardRef as ReactComponent };